import { FC } from 'react';
import styled from 'styled-components';
import { LCDD, LCDDProps } from '../shared/LCDD';

const StyledValueDropdown = styled(LCDD)<LCDDProps>`
    font-size: 15px;
    width: 100%;
    .dropdown-list-inner {
        margin-left: 10px;
        overflow-y: scroll;
        max-height: 300px;
    }
    .dropdown {
        float: none !important;
    }
`;

interface Country {
    key: string | undefined;
    value: string;
}
interface Props {
    value: {
        current: string;
        all: Country[];
    };
    onValueChange: (el: Country) => void;
}
const LCPerformerCountryDropdown: FC<Props> = ({ onValueChange, value }) => {
    const list = value.all;
    return (
        <StyledValueDropdown label={value.current} className="dropdown-lc lc-input">
            <ul>
                {Array.isArray(list) &&
                    list.map(element => (
                        <li key={element.key} onClick={() => onValueChange(element)}>
                            {element.value}
                        </li>
                    ))}
            </ul>
        </StyledValueDropdown>
    );
};

export default LCPerformerCountryDropdown;
